<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2024-02-29 17:16:04
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-16 14:14:14
 * @FilePath: \jsczt_vue20240117\src\views\moblie\list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="background: #f2f5f7">
    <div class="head">
      <div class="head_logo">
        <img src="../../assets/jscztmb_logo.png" alt="" />
      </div>
      <div class="head_name">江苏省预决算公开统一平台</div>
      <div class="head_nav">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          :class="activeTab == tab.id ? 'nav_btn actives' : 'nav_btn'"
          @click="changeTab(tab.id)"
        >
          {{ tab.name }}
        </div>
      </div>
    </div>
    <div class="curPosition">
      <div class="firstname"><van-icon name="arrow" />{{ title }}</div>
      <!-- <div class="secondname"><van-icon name="play" style="margin-right: 5px;" color="#f4ba08" />政府预算</div> -->
    </div>
    <div class="chooseBox">
      <div class="choicey" @click="changeYear">
        <div>
          <img
            src="../../assets/time.png"
            style="margin-top: 5px; margin-left: 10px"
            width="17px"
            height="17px"
          />
        </div>
        <div>{{ curyear }}年</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div class="choicey" @click="show1 = true">
        <div>
          <img
            src="../../assets/place.png"
            style="margin-top: 5px; margin-left: 10px"
            width="17px"
            height="17px"
          />
        </div>
        <div class="choiceTxt">{{ cityArea }}</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div v-if="custom" class="choicea" @click="startTimeshow = true">
        <div>
          <img
            src="../../assets/time.png"
            style="margin-top: 5px; margin-left: 10px"
            width="17px"
            height="17px"
          />
        </div>
        <div>{{ startTime }}</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div v-if="custom" class="choicea" @click="endTimeshow = true">
        <div>
          <img
            src="../../assets/time.png"
            style="margin-top: 5px; margin-left: 10px"
            width="17px"
            height="17px"
          />
        </div>
        <div>{{ endTime }}</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div
        v-if="activeTab == '25' && hasChild"
        class="choicea"
        @click="showbm = true"
      >
        <div class="choiceTxts">{{ bmName }}</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div
        v-if="activeTab == '25' && hasdwChild"
        class="choicea"
        @click="showdw = true"
      >
        <div class="choiceTxts">{{ dwName }}</div>
        <div style="margin-right: 10px"><van-icon name="arrow-down" /></div>
      </div>
      <div class="ensureBtn" @click="getListdata">确定</div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="chnldesc"
        closeable
        @change="onChange"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>
    <!-- 地域选择 -->
    <van-popup v-model="show1" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="optionsArea"
        :field-names="{
          text: 'chnldesc',
          value: 'areacode',
          children: 'child',
        }"
        @close="show1 = false"
        @change="handleCascaderChange"
      />
    </van-popup>
    <!-- 部门选择器 -->
    <van-popup v-model="showbm" round position="bottom">
      <van-picker
        title="选择部门"
        show-toolbar
        value-key="chnldesc"
        :columns="bmoptions"
        @confirm="onbmConfirm"
        @cancel="showbm = false"
      />
    </van-popup>
    <!-- 单位选择器 -->
    <van-popup v-model="showdw" round position="bottom">
      <van-picker
        title="选择单位"
        show-toolbar
        value-key="chnldesc"
        :columns="dwoptions"
        @confirm="ondwConfirm"
        @cancel="showdw = false"
      />
    </van-popup>
    <!-- 自定义年份 -->
    <van-popup v-model="startTimeshow" round position="bottom">
      <van-picker
        title="选择年份"
        show-toolbar
        value-key="name"
        :columns="startTimeoptions"
        @confirm="startConfirm"
        @cancel="startTimeshow = false"
      />
    </van-popup>
    <van-popup v-model="endTimeshow" round position="bottom">
      <van-picker
        title="选择年份"
        show-toolbar
        value-key="name"
        :columns="endTimeoptions"
        @confirm="endConfirm"
        @cancel="endTimeshow = false"
      />
    </van-popup>
    <div class="content">
      <van-loading class="listLoading" v-show="loading" />
      <div
        v-if="listData.length > 0"
        class="lists"
        @click="gotoDetail(item)"
        v-for="(item, index) in listData"
      >
        <div class="circle"></div>
        <div class="listtxt">{{ item.title }}</div>
        <div class="listtime">{{ item.showtime.slice(0, 11) }}</div>
      </div>
      <van-empty
        class="empty"
        v-if="listData.length == 0"
        description="暂无数据"
      />
    </div>
    <div class="footers">
      主办：江苏省财政厅 备案序号：苏ICP备15009401号 公安备案号：32010602010331
      网站标识码：3200000098 江苏省财政厅版权所有
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "moblieList",
  components: {},
  data() {
    return {
      startYear: null,
      endYear: null,
      cascaderValue: "",
      title: "",
      activeTab: "5",
      currentDate:'',
      pickerValue:'',
      loading:false,
      show1: false,
      showbm:false,
      showdw:false,
      custom:false,
      startTimeshow:false,
      startTime:'',
      endTimeshow:false,
      endTime:'',
      cityArea: "",
      bmName:'',
      dwName:'',
      listData: [],
      tabs: [
        { name: "预决算公开管理文件", id: "5" },
        { name: "政府预决算公开", id: "8" },
        { name: "部门预决算公开", id: "25" },
      ],
      curyear: "2020",
      show: false,
      columns: [],
      bmoptions:[],
      bmcolumn:[],
      dwoptions:[],
      dwcolumn:[],
      optionsArea: [],
      areaCode: "",
      parentId:'',
      hasChild:false,
      hasdwChild:false,
      deptCode:'',
      unitCode:'',
      yearRange: '',
      startTimeoptions:[],
      endTimeoptions:[]
    };
  },

  watch: {},
  created() {},
  mounted() {
    this.update();
    this.getYear();
    // this.getXzqh()
    // this.hasChilds(1)
  },
  methods: {
    update() {
      this.title = this.$store.state.sjName;
      this.activeTab = this.$store.state.sjParentid;
      const currentYear = new Date().getFullYear();
      // 创建一个包含过去10年年份的数组
      for (let i = 0; i < 10; i++) {
        this.startTimeoptions.push({'name':(currentYear - i)+"年",'value':currentYear - i});
        this.endTimeoptions.push({'name':(currentYear - i)+"年",'value':currentYear - i});
      }
      // console.log(this.startTimeoptions)
    },

    //自定义时间
    confirmTime(val){
      console.log(val)
    },
    validateRange() {
      if (this.startYear && this.endYear && this.startYear > this.endYear) {
        this.$message.error('开始年份不能大于结束年份');
        this.startYear = null; // 重置开始年份
      }
    },
    onRangeSelected() {
      if (this.startYear && this.endYear) {
        this.$emit('range-selected', { start: this.startYear, end: this.endYear });
      } else {
        this.$message.error('请选择有效的年份范围');
      }
    },
    // 获取年份
    async getYear() {
      this.columns = [];
      await this.$http.get("/api/wcmchannel/findYear").then((res) => {
        this.columns= res.data.data
        this.columns.push({'chnldesc': "自定义",'chnlname': "自定义"})
        this.curyear = this.$store.state.year?this.$store.state.year:this.columns[0].chnlname;
        this.getXzqh();
      });
    },
    changeTab(id) {
      this.activeTab = id;
      this.$store.commit("setSjParentid", id);
      this.$router.push({ name: "list" });
    },
    onChange(picker, value, index) {
      console.log(value);
      // this.show = false
    },
    startConfirm(val){
      this.startTime=val.name
      this.$store.commit('setstartYear',val.value)
      this.startTimeshow = false
    },
    endConfirm(val){
      console.log(val)
      this.endTime=val.name
      this.$store.commit('setendYear',val.value)
      this.endTimeshow = false
      this.getXzqh()
    },
    onConfirm(value) {
      if(value.chnlname!='自定义'&&this.activeTab != '25'){
        this.curyear = value.chnlname;
      // Toast ('选择成功');
        this.show = false;
        this.custom=false
        this.getXzqh();
      }else{
        this.curyear = value.chnlname;
        this.custom=true
        this.show = false;
      }

    },
    //改变年份
    changeYear() {
      this.show = true;
    },
    // 获取行政区
    async getXzqh() {
      let Year=''
      if(this.curyear=='自定义'){
        Year=this.$store.state.startYear+","+this.$store.state.endYear
        // console.log(Year)
      }
      this.optionsArea = [];
      await this.$http
        .get("/api/wcmchannel/findxzqh", {
          params: {
            year: this.curyear=='自定义'?Year.split(",")[1]:this.curyear,
            openType: "ys",
          },
        })
        .then((res) => {
          this.optionsArea.push(res.data.data);
          let place=this.$store.state.place
          let code=this.$store.state.code
          this.cityArea =place?place:this.optionsArea[0].chnldesc;
          this.areaCode = code?code:this.optionsArea[0].areacode;
          this.parentId = this.$store.commit("setSjChnlid",this.optionsArea[0].chnlid);
          this.getListdata();
        });
    },
    //切换地区
    handleCascaderChange(value) {
      let name = value.selectedOptions
        .map((option) => option.chnldesc)
        .join("/");
      this.cityArea = name;
      this.areaCode = value.value;
      var arrlist = [
			{ "areacode": "320000000", "chnlid": "126183", "child": this.optionsArea, "haschild": "true" }
					]
        if( this.activeTab=='25'){
          this.areachnlid(arrlist, this.areaCode)
          this.hasChilds(1)
        }
      // this.getListdata();
    },
    //获取列表
    getListdata() {
      // if (this.areaCode === '') {
      //   this.$message({
      //     message: '行政区不能为空',
      //     type: 'error'
      //   })
      // } else {
          let Yearlist=''
        if(this.curyear=='自定义'){
          if(this.$store.state.startYear>this.$store.state.endYear){
              Toast('开始时间不能大于结束时间');
          }else{
            Yearlist=this.$store.state.startYear+","+this.$store.state.endYear
            this.list(Yearlist)
          }
        }else{
          this.list('')
        }
      // }
    },
    //获取列表
    list(Yearlist){
      this.loading=true
        let dataparams={
            fileType: this.$store.state.sjFileType,
            areaCode: this.areaCode,
            year: this.curyear=='自定义'?Yearlist:this.curyear,
        }
        if(this.hasChild){
          dataparams.deptCode=this.deptCode
        }
        if(this.hasdwChild){
          dataparams.unitCode=this.unitCode
        }
        this.$http
        .post(
          "/api/yjsgk/findDataByFileType",
            dataparams
          ,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.listData = res.data.data;
            this.loading=false
          }
        });
    },
    //部门
    onbmConfirm(value, index) {
      // console.log(value)
      this.$store.commit("setSjChnlid",value.channelid)
      this.bmName=value.chnldesc
      this.deptCode=value.value
      this.showbm=false
      this.hasChilds(0)
    },
    //单位
    ondwConfirm(value, index) {
      // console.log(value)
      this.dwName=value.chnldesc
      this.unitCode=value.value
      this.showdw=false
      // this.hasChilds(0)
    },
    onbmChange(picker, value, index) {
      this.bmName=value.chnldesc
      this.deptCode=value.value
      this.showbm=false
      // this.hasChilds(0)
    },
    ondwChange(value, index) {
      this.dwName=value.chnldesc
      this.unitCode=value.value
      this.showdw=false
      this.hasChilds(0)
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    // 判断是否存在子集
    async hasChilds (e) {
      await this.$http.get('/api/wcmchannel/hasChild', {
        params: {
          parentId: this.$store.state.sjChnlid,
          classInfoId: this.$store.state.sjFileType,
          // 查询部门，部门1，单位0
          isgroup: 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          if(e==1){
            this.hasChild = res.data.data
          }else {
            this.hasdwChild = res.data.data
          }
          if (this.hasChild) {
            this.getbmDwList(e)
          }
          if (this.hasdwChild) {
            this.getbmDwList(e)
          }
        }
      })
    },
    // 获取部门/单位
    async getbmDwList (e) {
      await this.$http.get('/api/wcmchannel/bmDwList', {
        params: {
          parentId: this.$store.state.sjChnlid,
          classInfoId: this.$store.state.sjFileType,
          // 查询部门，部门1，单位0
          isgroup: e
        }
      }).then(res => {
        if (res.data.code === 200) {
          if(e==1){
            this.bmoptions = []
          this.bmcolumn=res.data.data
          this.bmName=this.bmcolumn[0].chnldesc
          this.deptCode=this.bmcolumn[0].deptcode
          res.data.data.forEach(item=>{
            this.bmoptions.push({'chnldesc':item.chnldesc,'value':item.deptcode,'channelid':item.channelid})
          })
          }else if(e==0){
            this.dwoptions = []
          this.dwcolumn=res.data.data
          this.dwName=this.dwcolumn[0].chnldesc
          this.unitCode=this.dwcolumn[0].deptcode
          res.data.data.forEach(item=>{
            this.dwoptions.push({'chnldesc':item.chnldesc,'value':item.deptcode})
          })
          }
        }
      })
    },
    areachnlid(arr, chnlid1) {
					arr.forEach(item => {
						if (item.areacode == chnlid1) {
              this.$store.commit("setSjChnlid",item.chnlid);
							return
						} else {
							if (item.haschild) {
								this.areachnlid(item.child, chnlid1);
							}
						}
					});
				},
    //文章页
    gotoDetail(item) {
      // console.log(item)
      let indexLast = this.cityArea.lastIndexOf('/'); // 获取最后一个/的位置
      let lastCity = this.cityArea.substring(indexLast + 1); // 截取最后一个/后的值
      this.$http.post('/yjsUbas/yjs/add', {
        browserVersion:navigator.appVersion,
    browserName: navigator.appName,
    browserLanguage:navigator.language,
    areaCode:item.areacode,
    areaName:lastCity,
    deptCode:this.deptCode,
    deptName:this.bmName,
    unitCode:this.unitCode,
    unitName:this.dwName,
    areaYear:this.curyear=='自定义'?this.$store.state.startYear+","+this.$store.state.endYear:this.curyear,
    sourceType:4,
    fileType:this.$store.state.sjFileType,
    docId:item.fileList[0].appdocid,
    title:item.title,
    channelId:item.channelId,
    url:location.origin + '/#/detail' + '?id=' + item.fileList[0].appdocid 
        }).then(res => {
          // if (res.data.code === 200) {
            // this.listData = res.data.data
          }
        )
      this.$router.push({
        name: "detail",
        query: { id: item.fileList[0].appdocid,
        },
      });
      let detailParams={
          'deptCode': this.deptCode,
          'deptName': this.bmName,
          'unitCode': this.unitCode,
          'unitName': this.dwName,
          'areaName':lastCity,
          'year':this.curyear
      }
      this.$store.commit('setdetailParams',detailParams)
    },
  },
};
</script>
<style scoped>
@import url("../../assets/list.css");
</style>



// WEBPACK FOOTER //
// src/views/moblie/moblieList.vue